/*
 * friendlyVoiceError — turns a raw voice-connection failure into calm,
 * learner-facing guidance. Raw browser/API messages ("Permission denied",
 * "OpenAI WebRTC 401: …") never reach the screen; they go to the console.
 *
 * Returns { kind: 'mic' | 'net', title, body, steps? } — `steps` is a short
 * numbered to-do the learner can follow before pressing Try again.
 */
export const friendlyVoiceError = (err, fallbackTitle = "Couldn't connect") => {
  const msg = String((err && (err.message || err)) || '');
  const name = (err && err.name) || '';

  if (name === 'NotAllowedError' || /permission denied|permission dismissed|not allowed/i.test(msg)) {
    return {
      kind: 'mic',
      title: 'Microphone access needed',
      body: 'Your browser is blocking the microphone for this site, so the spoken round can’t hear you.',
      steps: [
        'Click the lock (or tune) icon in the address bar',
        'Set Microphone to Allow',
        'Press Try again below',
      ],
    };
  }
  if (name === 'NotFoundError' || /device not found|no.*(microphone|audio input)/i.test(msg)) {
    return {
      kind: 'mic',
      title: 'No microphone found',
      body: 'Connect a microphone — or pick one in your system sound settings — then try again.',
    };
  }
  if (name === 'NotReadableError' || /could not start|in use|hardware/i.test(msg)) {
    return {
      kind: 'mic',
      title: 'Your microphone is busy',
      body: 'Another app seems to be using the mic. Close it (or pick a different input), then try again.',
    };
  }
  return {
    kind: 'net',
    title: fallbackTitle,
    body: 'The voice service didn’t respond. This is usually momentary — give it another try.',
  };
};

export default friendlyVoiceError;
